import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const settingApiUrl = `${baseApiUrl}/api/Setting`;


export async function getSetting(settingId) {
    return await httpRequest(fetchSetting.bind(this, settingId));
}

async function fetchSetting(settingId) {
    let config = getHttpHeaders();
    return await axios.get(`${settingApiUrl}?settingId=${settingId}&isDeleted=false`, config);
}
